<app-banner [heading]="'SCHOOL FACILITIES'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
    <!-- ======= Services Section ======= -->
<section id="services" class="services section-bg">
  <div class="container">
    <div class="row">

      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154474;"><i class="fa-solid fa-graduation-cap text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">World Class Infrastructure</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Well Landscaped Campus</a></h4>
          
        </div>
      </div>

      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-shuffle text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Fully Air Conditioned Campus</a></h4>

        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-chart-pie text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Smart Digital Classrooms</a></h4>
          
        </div>
      </div>

      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-quote-left text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">CCTV Enabled Campus</a></h4>

        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Full time Electricity Backup</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Well stocked World Class library</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Hitech &amp; Advanced Labs.</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">ICT Lab</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Computer Education from UKG to class X</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Art &amp; Innovation Studio</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Music Studio (Vocal and Instrumental)</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Dance Studio (Indian and Western)</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Well equipped Gymnasium</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Yoga Room</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Multi Purpose Sports &amp; Activity Room.</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">200 Meter Running Track.</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Cricket Pitches.</a></h4>
          
        </div>
      </div>
       <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Synthetic Tennis &amp; Basketball Court.</a></h4>
          
        </div>
      </div>
       <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Skating</a></h4>
          
        </div>
      </div>
       <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Badminton Court.</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Indoor games room (Chess, Carom ,Table Tennis)</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Outdoor fields for Lawn Tennis, Football, Volleyball, Athletics, Cricket, Basket Ball etc.</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Outdoor and Indoor Play Stations for Tiny Tots </a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Exposure to Foreign Language (French)grade 5 onwards  </a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Various clubs viz Science, Vedic Math, Eco, Home Science, IT, Dramatics, Public Speaking, Dance , Music , Art &amp; Craft  Etc.</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Extra coaching for Olympiad ,NTSE, Foundation of NEET/IIT- JEE</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Career Counselling</a></h4>
          
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white" style="color: #fff;"></i></div>
          <h4 class="title"><a href="#">Auditorium.</a></h4>
          
        </div>
      </div>
      
      
    </div>

  </div>
</section><!-- End Services Section -->

</main>